var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('basehead'),_c('div',[(parseInt(_vm.$route.params.identifier))?_c('IrealViewer',{attrs:{"emb":_vm.integration,"identifier":_vm.list_redirection[_vm.$route.params.identifier]}}):_c('IrealViewer',{attrs:{"emb":_vm.integration,"identifier":_vm.$route.params.identifier}}),_c('div',{staticClass:"mr-auto ml-auto mt-2 d-table"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }